export const FAVORITE_SOUNDS_STORAGE_KEY = 'tls.favoriteSounds.v1'
export const FAVORITES_UPDATED_EVENT = 'tls:favorites-updated'
export const MAX_FAVORITE_SOUNDS = 100
/** Most sounds one "Email me this list" message carries. */
export const SAVED_LIST_EMAIL_MAX = 50

export function sanitizeFavoriteSoundIds(value: unknown): string[] {
  if (!Array.isArray(value)) return []

  const unique = new Set<string>()

  for (const item of value) {
    if (typeof item !== 'string') continue

    const trimmed = item.trim()
    if (!trimmed) continue

    unique.add(trimmed)

    if (unique.size >= MAX_FAVORITE_SOUNDS) {
      break
    }
  }

  return Array.from(unique)
}

export function parseFavoriteSoundIds(rawValue: string | null): string[] {
  if (!rawValue) return []

  try {
    const parsed = JSON.parse(rawValue)
    return sanitizeFavoriteSoundIds(parsed)
  } catch {
    return []
  }
}

export function serializeFavoriteSoundIds(ids: string[]): string {
  return JSON.stringify(sanitizeFavoriteSoundIds(ids))
}

export function toggleFavoriteSoundId(currentIds: string[], soundId: string): {
  ids: string[]
  isFavorite: boolean
} {
  const normalizedSoundId = soundId.trim()

  if (!normalizedSoundId) {
    return { ids: sanitizeFavoriteSoundIds(currentIds), isFavorite: false }
  }

  const sanitized = sanitizeFavoriteSoundIds(currentIds)

  if (sanitized.includes(normalizedSoundId)) {
    return {
      ids: sanitized.filter((id) => id !== normalizedSoundId),
      isFavorite: false,
    }
  }

  return {
    ids: sanitizeFavoriteSoundIds([normalizedSoundId, ...sanitized]),
    isFavorite: true,
  }
}
